import React from 'react';
import { Avatar } from '@mui/material';
import cx from 'classnames';

import { resolveTaskPriorityParams } from 'components/root/Container/Layout/Tasks/Task/taskServices';

import './PriorityTaskNavigationIcon.scss';

export default function PriorityTaskNavigationIcon({ active, priority, task }) {
  const priorityParams = resolveTaskPriorityParams(priority);

  if (!priorityParams) {
    return <span key={task.taskId} className={cx('etc-body-navigation-item', { active })} />;
  }

  const { activeColor, color, backgroundColor, TaskIcon } = priorityParams;

  return (
    <Avatar
      className={cx('etc-priority-icon', { active })}
      sx={{ width: 16, height: 16, backgroundColor: active ? activeColor : backgroundColor }}
    >
      <TaskIcon
        sx={{
          fontSize: 11,
          color: color
        }}
      />
    </Avatar>
  );
}
